import React from "react";
import '../disclaimers/disclaimers.css'

const Terms = () =>{
    return(
        <div className="terms">
            <h1>Domits Terms and Conditions</h1>
            <input type="text" placeholder="Search within terms of conditions..." />
            <br />

            <h3>Disclaimer</h3>
            <p>Last updated: November, 2024 </p>
            <h3>Interpretation and Definitions </h3>

            <p>General Terms and Conditions for Domits</p>

            <p>These General Terms and Conditions outline the legal rights, responsibilities, and obligations of both the software company Domits
                (hereinafter referred to as "the Company") and the users (hereinafter referred to as "Users") who access or use the platform.
                 The platform provides services that facilitate online booking and rentals of accommodations (hereinafter referred to as "Services").
                  By using the platform, Users agree to comply with and be legally bound by these terms.</p>
            <hr/>
            <h4>1. Acceptance of Terms</h4>
            <p>By accessing or using the Company's platform, you agree to comply with and be bound by these Terms and Conditions. If you do not agree to these Terms, you must not use the platform.</p>

            <h4>2. Modification of Terms</h4>
            <p>The Company reserves the right to modify these Terms and Conditions at any time without prior notice. Any changes will be effective upon posting to the platform.
                 Your continued use of the Services after changes are posted constitutes acceptance of the updated Terms.</p>
            <br />
            <h4>3. Account Registration</h4>
            <p>
            <li><span className="bold">Eligibility</span>: To use certain features of the platform, you must register for an account. You must be at least 18 years old and capable of entering into legally binding contracts.</li>
            <li><span className="bold">Account Information</span>: All information provided during registration must be accurate, current, and complete. You are responsible for maintaining the confidentiality of your account information and for all activities conducted under your account.</li>
            <li><span className="bold">Account Termination</span>: The Company reserves the right to suspend or terminate your account if any breach of these Terms occurs.</li>
            </p>
            <br />

            <h4>4. Services Provided</h4>
            <p>
            <li>The Company acts as an intermediary platform that facilitates transactions between Users (e.g., hosts and guests). The Company does not own, operate, or manage any accommodations or rental properties listed on the platform.</li>
            <li><span className="bold">Listing</span>: Hosts are responsible for accurately describing and listing their properties, including setting prices, availability, and terms.</li>
            <li><span className="bold">Booking</span>: Users (guests) can book available listings as per the terms set by the host. All transactions are between the host and the guest, with the platform facilitating the booking process.
            </li>
            </p>

            <br />

            <h4>5. Payment Terms</h4>
            <p>
            <li><span className="bold">Service Fees</span>: The Company charge service fees to guests for the use of the platform’s Services. These fees will be clearly stated at the time of booking.</li>
            <li><span className="bold">Payment Process</span>: The platform facilitates payments between guests and hosts via third-party payment processors. The Company is not responsible for delays or errors caused by third-party services.</li>
            <li><span className="bold">Taxes</span>: Users are responsible for determining and fulfilling their own tax obligations related to the use of the platform and any income or transactions.</li>
            </p>


            <br />

            <h4>6. Cancellations and Refunds</h4>
            <p>
            <li><span className="bold">Cancellation by Guests</span>: Guests may cancel their reservations in accordance with the cancellation policy set by the host. Refunds are subject to the specific terms agreed upon between the host and guest.</li>
            <li><span className="bold">Cancellation by Hosts</span>: Hosts may cancel a booking only under exceptional circumstances as outlined in the Company’s policies. Repeated cancellations may result in account suspension.</li>
            <li><span className="bold">Force Majeure</span>: The Company is not liable for cancellations or interruptions due to unforeseeable events beyond reasonable control, such as natural disasters, governmental actions, or other force majeure events.</li>
            </p>

            <br />

            <h4>7. User Responsibilities</h4>
            <p>
            <li><span className="bold">Compliance with Laws</span>: Users agree to comply with all applicable local, state, national, and international laws and regulations when using the platform.
            <br />
            <br />
            <span className="bold">Prohibited Conduct</span>: Users shall not:
            <li> Use the platform for any unlawful purpose.</li>
            <li>Engage in fraudulent, abusive, or disruptive behavior.</li>
            <li> Post, upload, or transmit any harmful content, including viruses or malware.</li>
            <li> Discriminate against any User on the basis of race, gender, religion, or other protected characteristics.</li>
                </li>
            </p>

            <h4>8. Intellectual Property</h4>
            <p>
            <li><span className="bold">Ownership</span>: The platform and all content, trademarks, software, and related intellectual property are the exclusive property of the Company or its licensors.</li>
            <li><span className="bold">License</span>: Subject to compliance with these Terms, the Company grants Users a limited, non-exclusive, non-transferable, revocable license to use the platform for personal and non-commercial purposes.</li>
            <li><span className="bold">User Content</span>: Users grant the Company a worldwide, perpetual, royalty-free license to use any content (such as reviews, photos, etc.) they upload or submit to the platform for promotional or operational purposes.</li>
            </p>

            <br />

            <h4>9. Privacy</h4>
            <p>
            The Company’s use of personal information is governed by its Privacy Policy. By using the platform, you agree to the collection, use, and sharing of your data as described in the Privacy Policy.
            </p>

            <br />

            <h4>10. Dispute Resolution</h4>
            <p>
            <li><span className="bold">Governing Law</span>: These Terms shall be governed by and construed in accordance with the laws of The Netherlands, without regard to its conflict of law provisions.</li>
            <li><span className="bold">Arbitration</span>: Any disputes arising out of or relating to these Terms or the use of the platform will be resolved through binding arbitration, in accordance with the rules.</li>
            <li><span className="bold">Class Action Waiver</span>: You agree to resolve any disputes on an individual basis and waive any right to participate in a class action lawsuit or class-wide arbitration.</li>
            </p>

            <br />

            <h4>11. Limitation of Liability</h4>
            <p>
            <li><span className="bold">No Warranty</span>: The Company provides the platform “as is” and “as available” without any warranties, express or implied. The Company disclaims all warranties of merchantability, fitness for a particular purpose, and non-infringement.</li>
            <li><span className="bold">Limitation of Damages</span>: To the fullest extent permitted by law, the Company will not be liable for any indirect, incidental, punitive, or consequential damages, including loss of profits, data, or goodwill.</li>
            </p>

            <br />

            <h4>12. Indemnification</h4>
            <p>
            Users agree to indemnify, defend, and hold harmless the Company, its officers, employees, and affiliates from any claims, damages, losses, or liabilities arising from:
            <li>Their use of the platform.</li>
            <li>Violation of these Terms.</li>
            <li>Violation of any rights of a third party, including intellectual property rights.</li>
            </p>

            <br />

            <h4>13. Termination of Use</h4>
            <p>
            The Company reserves the right to terminate or suspend access to the platform for any User at any time for any reason, including violation of these Terms, without prior notice.
            </p>

            <br />

            <h>12. Indemnification</h>
            <p>
            Users agree to indemnify, defend, and hold harmless the Company, its officers, employees, and affiliates from any claims, damages, losses, or liabilities arising from:
            <li><span className="bold">Entire Agreement</span>: These Terms, together with the Privacy Policy and any other agreements incorporated by reference, constitute the entire agreement between the User and the Company.</li>
            <li><span className="bold">Severability</span>: If any provision of these Terms is deemed invalid or unenforceable, the remaining provisions will continue in full force and effect.</li>
            <li><span className="bold">No Waiver</span>: The failure of the Company to enforce any right or provision of these Terms will not constitute a waiver of that right.</li>
            </p>

            <br />

            <hr/>
            <p>By using the platform, you acknowledge that you have read, understood, and agreed to these General Terms and Conditions.</p>
            <hr/>
            <br />
        </div>
    );
}

export default Terms;
